import React, {useCallback, useMemo, useTransition} from 'react';
import {
	LinkCompat as FluentLink,
	SpinnerCompat as Spinner,
	FontIconCompat as FontIcon,
	StackCompat as Stack,
	DefaultButtonCompat as DefaultButton,
	CommandBarButtonCompat as CommandBarButton,
} from 'components/FluentUICompat';
import {AttachmentRef} from 'types';
import {useBaselineDetailsPageTranslations} from '../BaselineDetailsPage/BaselineDetailsPage.utils';

interface Props {
	attachmentRefs: AttachmentRef[];
	showText?: boolean;
}

export function BaselineDownloadBtn({
	attachmentRefs,
	showText,
}: Props): React.ReactElement {
	if (attachmentRefs.length === 0) {
		return <Spinner></Spinner>;
	}
	const uri = attachmentRefs.at(0)?.file.uri;

	return (
		<FluentLink target='_blank' download={false} href={uri}>
			<FontIcon iconName='Download' style={{fontSize: 20, paddingLeft: 5}} />
		</FluentLink>
	);
}
